import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65fb4f8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bbs-tabel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bbs-tabel-title" }, "非会员报名表", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from '../components/bottom.vue'
import { MoreFilled } from '@element-plus/icons-vue'

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from '@element-plus/icons-vue'
import type { UploadFile, ElFile } from 'element-plus/es/components/upload/src/upload.type'

      type FormInstance = InstanceType<typeof ElForm>;
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activitiesStep = [
        {
            content: '提交申请',
            timestamp: '2018-04-12 20:46',
            size: 'large',
            type: 'primary',
            icon: MoreFilled,
        },
        {
            content: '审核',
            timestamp: '2018-04-03 20:46',
            color: '#0bbd87',
        },
        {
            content: '结果',
            timestamp: '2018-04-03 20:46',
            size: 'large',
        },
        ];

    const activityApplyFormRef = ref<FormInstance>();

    const ustore = useStore();
    const bindData = reactive({
      activityApplyForm:{
        activityId:'',
        contact: '',
        mobile: '',
        explanation:'',
    }
    });

    var id = router.currentRoute.value.params.id;
    if(typeof id == "string") { 
        bindData.activityApplyForm.activityId = id;
    }

    const defaultValidate = (rule: any, value: any, callback: any) => {
      if (value === "") {
        callback(new Error("请填写联系人"));
      } else {
        callback();
      }
    };

    const activityApplyRules = reactive({
      contact: [{ required: true, validator: defaultValidate, trigger: "blur" }],
      mobile: [{ required: true, message: '请填写电话', trigger: "blur" }],
    });


    const submitForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          store.dispatch("frontBbsModule/unloginSaveActivityApply", bindData.activityApplyForm).then(
            (data) => {
              //成功
              ElMessage.success("保存成功.");
            },
            (error) => {
              ElMessageBox.alert(error.msg, "系统消息", {
                confirmButtonText: "关闭",
                callback: (action: Action) => {},
              });
            }
          );
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      console.log("exec...resetForm");
      if (!formEl) return;
      formEl.resetFields();
    };

  const active = ref(0)


return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_steps, {
        active: active.value,
        "finish-status": "success"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(activitiesStep, (activityStep, index) => {
            return _createVNode(_component_el_step, {
              key: index,
              title: activityStep.content
            }, null, 8, ["title"])
          }), 64))
        ]),
        _: 1
      }, 8, ["active"]),
      _createVNode(_component_el_form, {
        class: "bbs-tabel-ct",
        model: _unref(bindData).activityApplyForm,
        ref_key: "activityApplyFormRef",
        ref: activityApplyFormRef,
        "label-width": "120px",
        "status-icon": "",
        rules: _unref(activityApplyRules)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "联系人",
            prop: "contact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.contact,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).activityApplyForm.contact) = $event)),
                "input-style": "width:300px",
                placeholder: "",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "电话",
            prop: "mobile"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.mobile,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).activityApplyForm.mobile) = $event)),
                "input-style": "width:300px",
                placeholder: "",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "附言",
            prop: "explanation"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                "input-style": "width:500px",
                modelValue: _unref(bindData).activityApplyForm.explanation,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).activityApplyForm.explanation) = $event)),
                type: "textarea",
                autosize: { minRows: 4, maxRows: 8 },
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_el_container, { class: "bbs-tabel-btn" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElButton), {
            type: "primary",
            size: "large",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm(activityApplyFormRef.value)))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(Bottom)
  ]))
}
}

})